import * as ActionTypes from './action-types';

export const appNavigated = (path: string): ActionTypes.IAppNavigatedAction => ({
  type: ActionTypes.APP_NAVIGATED,
  payload: { path },
});
